<script lang="ts">
    import Hls from "hls.js";
    import { onDestroy } from "svelte";

    interface Props {
        source: string;
    }

    let { source, ...rest }: Props = $props();

    let element: HTMLVideoElement | null = $state(null);
    const hls: Hls = new Hls();

    onDestroy(function () {
        hls.removeAllListeners();
        hls.detachMedia();
        hls.destroy();
    });

    function setupVideo(source: string): void {
        if (Hls.isSupported()) {
            hls.loadSource(source);
            hls.startLoad();
        } else if (element.canPlayType("application/vnd.apple.mpegurl")) {
            element.src = source;
        }
    }

    export function getElement() {
        return element;
    }

    $effect(function () {
        if (element) {
            hls.attachMedia(element);
            setupVideo(source);
        }
    });
</script>


    <video bind:this={element} {...rest}></video>

